export const baseUrl = 'https://api.getbound.ai';
// export const baseUrl = 'https://localhost:44322';
